import { FeedbackContext } from '@/feedback/context';
import { I18nMobileInput } from '@ali/merlion-ui';
import * as $18n from '@alife/lazada-i18n';
import { Form, FormItem, Input } from '@formily/antd-v5';
import { Field } from '@formily/react';
import { Rate } from 'antd';
import { useContext } from 'react';
import { Uploader } from '../Uploader';
import i18Input from '../i18-input';

export const FeedbackForm = ({ form, country }) => {
  const { text, accountRequired } = useContext(FeedbackContext);

  return (
    <Form form={form} layout="vertical">
      <div
        style={{ lineHeight: '24px', marginBottom: 8, whiteSpace: 'pre-wrap' }}
        dangerouslySetInnerHTML={{
          __html:
            text?.subTitle ||
            /*#__PURE__*/$18n.get(
              'asc-fb.feedback-form.account.hint',
              'Please enter you login email or phone number'
            ),
        }}
      />
      <Field
        name="email"
        required={accountRequired === 'both'}
        title={/*#__PURE__*/$18n.get('page.account.setting.loginEmailAddress', 'Login email')}
        decorator={[FormItem]}
        component={[Input, { placeholder: text?.emailHolder || '' }]}
        validator="email"
      />
      <Field
        name="phone"
        required={accountRequired === 'both'}
        title={/*#__PURE__*/$18n.get('page.common.phoneNumber', 'Phone Number')}
        decorator={[FormItem]}
        component={[i18Input, { country, placeholder: text?.phoneHolder || '' }]}
        validator={{
          validator(value) {
            if (!value) return true;
            return I18nMobileInput.isPossiblePhoneNumber(value);
          },
          message: 'Invalid phone number',
        }}
      />
      <Field
        name="answerText"
        title={/*#__PURE__*/$18n.get('asc-fb.feedback-form.description-label', 'Detailed description')}
        required
        decorator={[FormItem]}
        component={[
          Input.TextArea,
          {
            style: { height: 100, resize: 'none' },
            placeholder:
              text?.descHolder ||
              /*#__PURE__*/$18n.get(
                'asc-fb.feedback-form.description-holder',
                'Please share your thoughts with us.'
              ),
            maxLength: 300,
          },
        ]}
      />
      <Field
        name="rate"
        title={/*#__PURE__*/$18n.get('asc-fb.feedback-form.rating-label', 'How would you rate your experience?')}
        required
        decorator={[FormItem]}
        component={[
          Rate,
          {
            style: { color: '#4070f4' },
          },
        ]}
      />
      <Field
        name="imageUrlList"
        title={`${/*#__PURE__*/$18n.get('asc-fb.feedback-form.upload-files', 'Total File')} (0/3)`}
        required
        decorator={[FormItem]}
        component={[Uploader, { form }]}
        reactions={(field) => {
          field.setState((state) => {
            state.title = `${/*#__PURE__*/$18n.get('asc-fb.feedback-form.upload-files', 'Total File')} (${
              field.value?.length || 0
            }/3)`;
          });
        }}
      />
    </Form>
  );
};
